<template>
  <div class="send-msg-code">
    <div class="text-btn" v-if="!canSendCode" @click="sendCode">获取验证码</div>
    <div class="text-btn" v-else>{{ second }}s后重发</div>
  </div>
</template>

<script >
  import { Notify } from "vant";
  import { sendPhoneCodeTwo as sendPhoneCodeApi } from "@/api/bind.js";
  import { validatorPhone } from "@/utils/validator.js";
  
export default {
  name: 'SendMsgCode',
  components: {
  },
  props: {
    phoneNumber: {
      type: String,
      default: () => '',
    },
       // 数据
    data: {
      type: [Array, Object],
      default: () => {},
    },
    // 接口地址
    apiFunc: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      secondMax:120,// 发送验证码倒计时总时长
      timer:null,// 倒计时时钟id
      second: 120 // 发送验证码倒计时
    }
  },
  created() {

  },
  computed:{
     // 是否已发送验证码
     canSendCode(){

    return  +this.second > 0 &&  +this.second < +this.secondMax;
     }

  },
mounted(){
},
  methods: {

   // 发送验证码
   sendCode() {
    console.log(validatorPhone(this.phoneNumber));
    if (validatorPhone(this.phoneNumber)) {
      return Notify({
        type: "danger",
        message: validatorPhone(this.phoneNumber),
      });
    }

    console.log(2);


    // const apiFunc = typeof this.apiFunc === "function" ? this.apiFunc : sendPhoneCodeApi;
    // console.log(apiFunc);
    sendPhoneCodeApi({
      ...this.data,
    }).then((res) => {
      Notify({
        type: "success",
        message: "发送验证码成功",
      });
      this.startCountDown();
    });
  },
    // 开始倒计时
   startCountDown() {
    this.clearCountDown(this.timer);
    // this.countDownHandle();
    this.timer = setInterval(()=>{
  // 倒计时方法
    this.second -= 1
    if (+this.second <= 0) {
      this.second =  this.secondMax;
      this.clearCountDown(this.timer);
    }
    }
        , 1000);
  },

  // 倒计时方法
  //  countDownHandle() {
  //   this.second -= 1
  //   console.log('this.second1',this.second);
  //   if (+this.second <= 0) {
  //     this.second =  this.secondMax;
  //     this.clearCountDown(this.timer);
  //   }
  // },

  // 清除倒计时
   clearCountDown(id) {
    clearInterval(id);
  }

}
}

</script>
<style lang="less" scoped>
  .send-msg-code {
    .text-btn {
      font-size: 15px;
      color: #007ff0;
    }
  }
</style>
